import React, { useState } from 'react';
import axios from 'axios';
import './../../styles/default/contacto.css';
import * as globals from './../../components/GlobalScripts.js';
import Banner from './Banner';

const Contacto = () => {
    let path_api = localStorage.getItem('path_api');
    const [formContact, setFormContact] = useState({});

    const handleChangeContact = (e) => {
        const { name, type, checked, value } = e.target;
        const newValue = type === "checkbox" ? checked : value;
        setFormContact({ ...formContact, [name]: newValue });
    };

    const handleSubmitContact = (e) => {
        e.preventDefault();
        globals.openViewCharge();
        axios.post(`${path_api}/default/contacto.php`, {
            formContact
        }).then(response => {
            if (response.data.mensaje === "success") {
                globals.createAlert({
                    type: "success",
                    msg_title: "Enviado",
                    msg: "Tu mensaje se envio correctamente.",
                    effect: "opacidad 2s, desplazamiento 2s"
                });
                setFormContact({});
            } else {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: response.data.mensaje || "El mensaje no se envio",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
            }
        }).catch(error => {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error al contectar con el servidor",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000
            });
        }).finally(() => {
            globals.closeViewCharge();
        });
    };

    return (
        <Banner id="contacto" src="/imagenes/home/contact.webp" type="imagen" overlay="black">
            <div className='container-section high-section section flex-row gap-40'>
                <div className="flex-column gap-20 full-width">
                    <p className="title text-white">Contactanos</p>
                    <h2 className="text-white">¿Necesitas ayuda?</h2>
                    <h5 className="text-white">Estamos aquí para resolver todas tus dudas y brindarte la atención personalizada que mereces.</h5>
                </div>
                <form onSubmit={handleSubmitContact} className="contact">
                    <h3 className="text-white">¡Escribenos!</h3>
                    <p className="text-white">Cuéntanos en qué podemos ayudarte y nuestro equipo se comunicará contigo lo antes posible.</p>

                    <div className="flex-column gap-10 full-width">
                        <div className="form-group">
                            <input
                                type="text"
                                name="nombre"
                                value={formContact.nombre}
                                onChange={handleChangeContact}
                                className="input-primary"
                                placeholder="Nombre completo"
                                required
                            />
                        </div>

                        <div className="form-grop-row" style={{ gap: '10px' }}>
                            <div className="form-group">
                                <input
                                    type="tel"
                                    name="telefono"
                                    value={formContact.telefono}
                                    onChange={handleChangeContact}
                                    className="input-primary"
                                    placeholder="Telefono"
                                    required
                                />
                            </div>

                            <div className="form-group">
                                <input
                                    type="email"
                                    name="correo"
                                    value={formContact.correo}
                                    onChange={handleChangeContact}
                                    className="input-primary"
                                    placeholder="Correo"
                                    required
                                />
                            </div>
                        </div>

                        <div className="form-group">
                            <textarea
                                name="mensaje"
                                className="input-primary"
                                value={formContact.mensaje}
                                onChange={handleChangeContact}
                                placeholder="Mensaje"
                                rows="5"
                            />
                        </div>
                    </div>

                    <button className="button-primary white">Enviar</button>
                </form>
            </div>
        </Banner>
    );
};

export default Contacto;